import * as z from "zod";

type MessageLike = {
  role: string;
  metadata?: Record<string, unknown> | null;
};

const ReviewRunRow = z.object({ child_session_id: z.string() });

/** Metadata of a live webhook review card's placeholder row (see placeReviewCards). */
export function reviewRunRowMetadata(childSessionId: string) {
  return { review_run: { child_session_id: childSessionId } };
}

export function reviewRunRowChildId(message: MessageLike): string | null {
  const raw = message.metadata?.review_run;
  if (message.role !== "agent" || raw === undefined) return null;
  const parsed = ReviewRunRow.safeParse(raw);
  return parsed.success ? parsed.data.child_session_id : null;
}

export function isReviewRunRow(message: MessageLike): boolean {
  return reviewRunRowChildId(message) !== null;
}
